import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { AccountScreen } from '@/features/account/routes/account-screen'
import { pageTitle } from '@/lib/brand'

export const Route = createFileRoute('/account')({ component: Account })

function Account() {
  useEffect(() => {
    document.title = pageTitle('Account')
  }, [])

  return <AccountScreen />
}
